export default {
  CREATE_NEW_RECORD_SUCCESS(state, data) {
    state.newRecordResponse = data
    state.errors.newRecordResponseError = null
  },
  CREATE_NEW_RECORD_ERROR(state, error) {
    state.errors.newRecordResponseError = error
  },
  GET_DB_RECORDS_LIST_SUCCESS(state, data) {
    state.dbRecordsList = data
    state.errors.dbRecordsListError = null
  },
  GET_DB_RECORDS_LIST_ERROR(state, error) {
    state.errors.dbRecordsListError = error
  },
  CREATE_RECORD_LOADING(state, data) {
    state.loading.createRecord = data
  },
  UPLOAD_EXCEL_LOADING(state, data) {
    state.loading.uploadExcel = data
  },
  SEARCH_DB_RECORDS_SUCCESS(state, data) {
    state.dbRecordsList = data
    state.errors.searchDbRecordsError = null
  },
  SEARCH_DB_RECORDS_ERROR(state, error) {
    state.errors.searchDbRecordsError = error
  },
  DELETE_RECORD_SUCCESS(state, payload) {
    state.deleteRecordResponse = payload
  },
  EDIT_RECORD_SUCCESS(state, payload) {
    state.editRecordResponse = payload
  },
  CREATE_NEW_RECORD_AND_EXIT_ERROR(state, error) {
    state.errors.createRecordAndExitError = error
  },
  CREATE_NEW_RECORD_AND_EXIT_SUCCESS(state, payload) {
    state.createRecordResponse = payload
    state.errors.createRecordAndExitError = null
  },
  UPLOAD_EXCEL_LOADING_SUCCESS(state, payload) {
    state.uploadExcelResponse = payload
    state.errors.uploadExcelError = null
  },
  UPLOAD_EXCEL_FILE_ERROR(state, error) {
    state.errors.uploadExcelError = error
  },
  DELETE_RECORD_ERROR(state, error) {
    state.errors.deleteRecordError = error
  },
  EDIT_RECORD_ERROR(state, error) {
    state.errors.editRecordError = error
  },
  GET_USER_FORM_FIELDS_SUCCESS(state, payload) {
    state.userFormFields = payload
  },
  POST_USER_FORM_FIELDS_SUCCESS(state, payload) {
    state.userFormFieldsResponse = payload
  },
  POST_USER_FORM_FIELDS_ERROR(state, error) {
    state.errors.postUserFormFieldsError = error
  },
  POST_USER_FORM_FIELDS_LOADING(state, payload) {
    state.loading.postUserFormFields = payload
  },
  SET_ID_FOR_EXCEL_UPLOAD(state, payload) {
    state.excelId = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/db/mutations.js